import { createSelector } from '@reduxjs/toolkit';
import { categoriesAdapter } from '~SpectateStore/slices/categoriesSlice';
import { selectEventCategoryId } from './eventsSelectors';

export const {
    selectById: selectCategoryById,
} = categoriesAdapter.getSelectors(state => state.categories);

export const selectCategoryName = (state, categoryId) => selectCategoryById(state, categoryId)?.name;
export const selectCategorySlug = (state, categoryId) => selectCategoryById(state, categoryId)?.slug;

export const selectCategorySlugByEventId = createSelector(
    [
        state => state,
        selectEventCategoryId,
    ],
    (state, categoryId) => selectCategorySlug(state, categoryId),
);

export const selectIsUsFormat = createSelector(
    [
        state => state,
        selectEventCategoryId,
    ],
    (state, categoryId) => selectCategoryById(state, categoryId)?.isUsFormat,
);
